// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3_dM3","label":"Category_label__URFc1","content":"Category_content__2yhJi","header":"Category_header__3T90O","location":"Category_location__2KgOQ"};